// import { historyList } from '../config/apiUrl'
import API from "../services";
const { getHistoryList, getHonorList } = API.dataqin;

const getHistoryData = async (params, _isBrowser) => {
  return new Promise((resolve) => {
    historyList(params, _isBrowser).then((result) => {
      resolve({
        record: result,
      });
    });
  });
};

export default {
  namespace: "about",
  state: {
    historylist: [],
    total: 0,
    honorList: [],
  },
  reducers: {
    initHistory(state, { payload }) {
      return {
        ...state,
        historylist: payload,
        total: payload.length,
      };
    },
    initHonor(state, { payload }) {
      return {
        ...state,
        honorList: payload,
      };
    },
  },
  effects: {
    *setHistory({ payload }, { put }) {
      yield put({
        type: "initHistory",
        payload: payload.record,
      });
    },
    // 获取发展历程列表
    *getHistoryList({ payload, _isBrowser }, { call, put }) {
      const result = yield call(getHistoryList, payload);
      // 成功
      yield put({
        type: "initHistory",
        payload: result,
      });
    },
    // 获取 关于 页面 #horor 部分的数据
    *getAboutHonorList({ payload, _isBrowser }, { call, put }) {
      let result = yield call(getHonorList, payload, _isBrowser);
      //控制数量
      let data = result.records;
      if (data && data.length > 6) {
        data = data.slice(0, 6);
      }
      // 成功
      yield put({
        type: "initHonor",
        payload: data,
      });
    },
  },
};
